import NO_COMMUNICATION from "@/assets/alerts/connectivity-alert-v2.svg";
import NO_SCHEDULES from "@/assets/alerts/no-schedule-alert-v2.svg";
import FEED_NOT_BEING_DISPENSED from "@/assets/alerts/feed-alert-v2.svg";
import MOTOR_RELAY_ISSUE from "@/assets/alerts/motor-retail-failure-v2.svg";
import SCHEDULE_NOT_UPDATED from "@/assets/alerts/schedules-not-updated-v2.svg";
import LOW_DO from "@/assets/alerts/low-do-alert-v2.svg";
import LOW_BATTERY from "@/assets/navigation/nav-battery.svg";
export default {
  renderAlertName(data) {
    switch (data) {
      case "NO_COMMUNICATION":
        return `NO_COMMUNICATION`;
      case "NO_SCHEDULES":
        return `PM_no_sch_today`;
      case "SCHEDULE_NOT_UPDATED":
        return "PM_sch_not_updated";
      case "FEED_NOT_BEING_DISPENSED":
        return `FEED_NOT_BEING_DISPENSED`;
      case "LOW_BATTERY":
        return `ALERTS_LOW_BATTERY`;
      case "NO_FEED_OR_FEED_STUCK":
        return `PM_NO_FEED_ALERT`;
      case "MOTOR_RELAY_ISSUE":
        return `PM_motor_failure_alert`;
      case "LOW_DO":
        return "Comn_low_do";
      case "CRITICAL_DO":
        return "Comn_critical_do";
      default:
        return data;
    }
  },
  renderDeviceAlertIcon(data) {
    switch (data) {
      case "NO_COMMUNICATION":
        return NO_COMMUNICATION;
      case "NO_SCHEDULES":
        return NO_SCHEDULES;
      case "FEED_NOT_BEING_DISPENSED":
        return FEED_NOT_BEING_DISPENSED;
      case "NO_FEED_OR_FEED_STUCK":
        return FEED_NOT_BEING_DISPENSED;
      case "MOTOR_RELAY_ISSUE":
        return MOTOR_RELAY_ISSUE;
      case "SCHEDULE_NOT_UPDATED":
        return SCHEDULE_NOT_UPDATED;
      case "LOW_DO":
        return LOW_DO;
      case "CRITICAL_DO":
        return LOW_DO;
      case "LOW_BATTERY":
        return LOW_BATTERY;
      default:
        return NO_COMMUNICATION;
    }
  },
};
